<div class="card mb-4">
    <div class="card-header">
        <h3>Routing de Productos</h3>
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="col-md-6">
                <h6>Producto Entrada</h6>

                <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productEntry"
                    [placeholder]="'Ingresa un producto entrada'" [filterElements]="filterProductsEntry"
                    [typeElements]="'product-order'" (inputMethod)="writeProductEntry($event.event)"
                    (changeStatus)="checkProductEntry($event.filterElement)" (getTitle)="
            $event.filterElement.title =
              $event.filterElement.code + ' - ' + $event.filterElement.name
          "></app-input-autocomplete>
            </div>

            <div class="col-md-6">
                <h6>Producto Salida</h6>

                <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.productOutput"
                    [placeholder]="'Ingresa un producto salida'" [filterElements]="filterProductsOutput"
                    [typeElements]="'product-order'" (inputMethod)="writeProductOutput($event.event)"
                    (changeStatus)="checkProductOutput($event.filterElement)" (getTitle)="
            $event.filterElement.title =
              $event.filterElement.code + ' - ' + $event.filterElement.name
          "></app-input-autocomplete>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
            <button class="btn btn-outline-secondary" (click)="reset()">
                Limpiar
            </button>

            <button class="btn btn-success" [disabled]="!inputs.productEntry.data?.id || !inputs.productOutput.data?.id"
                (click)="saveRouting()">
                Guardar Routing
            </button>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header">
        <h3>Routing Asignaciones</h3>
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
                <table class="table table-striped" style="margin-bottom: 0; margin-top: 10px;">
                    <thead>
                        <tr class="tr-middle">
                            <th class="ta  bg-info-subtle">
                                Código Entrada
                            </th>
                            <th class="ta  bg-info-subtle">
                                Producto Entrada
                            </th>
                            <th class="ta">
                                Código Salida
                            </th>
                            <th class="ta">
                                Producto Salida
                            </th>
                            <th class="ta">
                                Acción
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr-middle" *ngFor="let routing of routingProductList">
                            <td class="col bg-info-subtle">
                                {{routing.productEntryData.code}}
                            </td>
                            <td class="col bg-info-subtle">
                                {{routing.productEntryData.name}}
                            </td>
                            <td class="col">
                                {{routing.productSaleData.code}}
                            </td>
                            <td class="col">
                                {{routing.productSaleData.name}}
                            </td>
                            <td class="col">
                                <span class="clickeable text-danger a-hover" (click)="deleteRouting(routing.id)">
                                    <i *ngIf="!deleting[routing.id]" class="fa fa-trash"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</div>